<div class="container">
  <div class="row header">
    <div class="col">
      <p class="header-title">{{ 'importCart.title' | cxTranslate }}</p>
    </div>
  </div>

  <div class="row description">
    <div class="col-12 col-md">
      <p class="description-text">{{ 'importCart.description' | cxTranslate }}</p>
      <div class="description-detail">
        <ul class="description-list">
          <li>{{ 'importCart.quantity' | cxTranslate }}</li>
          <li>{{ 'importCart.size' | cxTranslate }}</li>
        </ul>

        <app-custom-button
          styleClass="btn-small"
          [title]="'importCart.downloadTemplate' | cxTranslate"
          [showSpinner]="showSpinnerDownloadTemplate"
          (clicked)="downloadCsvTemplate()"
        ></app-custom-button>
      </div>
    </div>

    <div class="col-auto line d-none d-md-block"></div>

    <div class="col-12 col-md choose-file">
      <p>{{ 'importCart.chooseFileTitle' | cxTranslate }}</p>
      <app-custom-button
        styleClass="btn-small"
        [title]="selectedFile ? selectedFile.name : ('importCart.chooseFile' | cxTranslate)"
        [showSpinner]="showSpinnerValidateCsv"
        (clicked)="inputFile.click()"
        [disableBtn]="disableOnUpload"
      ></app-custom-button>
      <input
        #inputFile
        type="file"
        accept=".csv"
        class="d-none"
        [(ngModel)]="fileInputControl"
        (change)="browseFile($event.target.files)"
      />
    </div>
  </div>

  <div class="row import">
    <div class="col no-padding">
      <app-custom-button
        styleClass="btn-small"
        [title]="'importCart.import' | cxTranslate"
        [showSpinner]="showSpinnerUpload"
        (clicked)="uploadCSV()"
        [disableBtn]="disableUploadCSV"
      ></app-custom-button>
    </div>
  </div>
</div>
